import React from 'react';
import { ImageIcon } from 'lucide-react';
import { PendingMarker } from './PendingMarker';
import { testimonials, isTestimonialReady } from '../data/pendingContent';
type TestimonialsProps = {
  draftPreview: boolean;
};
export function Testimonials({
  draftPreview
}: TestimonialsProps) {
  // Versione pubblica: solo testimonianze reali complete. Vista di lavoro: tutti e sei gli spazi.
  const items = draftPreview ? testimonials : testimonials.filter(isTestimonialReady);
  if (items.length === 0) return null;
  return <section aria-labelledby="testimonials-title" className="bg-cream px-5 sm:px-8 py-16 sm:py-24" data-id="element-215" data-mp="31z3bqrdu9j8x">
      <div className="max-w-6xl mx-auto" data-id="element-216" data-mp="2x1l0uvg9gtya">
        <h2 id="testimonials-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-plum" data-id="element-217" data-mp="2x2mkhobceorm">
          Le vostre parole, le vostre creazioni
        </h2>

        <ul className="mt-10 columns-1 md:columns-2 lg:columns-3 gap-5" data-id="element-218" data-mp="v7c85aw5tdri">
          {items.map(t => {
          const hasQuote = t.quote.trim().length > 0;
          const withImage = t.withImage ?? Boolean(t.image);
          return <li key={t.id} className="mb-5 break-inside-avoid" data-id="element-219" data-mp="m4rm673zp43s">
                <figure className="overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-soft" data-id="element-220" data-mp="m6cdzoyx68xy">
                  {withImage && (t.image ? <div className="relative" data-id="element-221" data-mp="c6lknqm3hzzg">
                        <img src={t.image} alt={t.imageAlt ?? ''} loading="lazy" decoding="async" className="block aspect-[4/5] w-full object-cover" data-id="element-222" data-mp="c7dh13nio1qs" />
                        {t.imageIsIllustration}
                      </div> : <div className="flex aspect-[4/5] w-full flex-col items-center justify-center gap-3 bg-blush text-center" data-id="element-223" data-mp="14ur6yhssrx1e">
                        <ImageIcon size={28} aria-hidden="true" className="text-berry-deep/70" data-id="element-224" data-mp="v5ps4uxznlp0" />
                        <PendingMarker data-id="element-225" data-mp="v3d4c15juh41">Foto reale della creazione in arrivo</PendingMarker>
                      </div>)}
                  <div className={withImage ? 'px-6 pb-6 pt-5' : 'p-6 sm:p-7'} data-id="element-226" data-mp="1nlqs17x68mpe">
                    {hasQuote ? <blockquote className={`leading-relaxed text-ink ${withImage ? 'text-base' : 'font-serif text-lg sm:text-xl'}`} data-id="element-227" data-mp="1xhqwjkgjbkrw">
                        « {t.quote} »
                      </blockquote> : <div aria-label="Testimonianza in arrivo" data-id="element-228" data-mp="1sh33yucnqvvk">
                        <div aria-hidden="true" className="space-y-2.5" data-id="element-229" data-mp="1ofrf4r1lyeof">
                          <div className="h-3 w-full rounded-full bg-ink/10" data-id="element-230" data-mp="1jh6dcn6pjmxv" />
                          <div className="h-3 w-11/12 rounded-full bg-ink/10" data-id="element-231" data-mp="1ejoddmao4i20" />
                          <div className="h-3 w-2/3 rounded-full bg-ink/10" data-id="element-232" data-mp="19sepaq4rpms8" />
                        </div>
                        <PendingMarker className="mt-4" data-id="element-233" data-mp="14t24eaxgipsa">Testimonianza reale in arrivo</PendingMarker>
                      </div>}
                    {t.name && <figcaption className="mt-4 text-sm" data-id="element-234" data-mp="10srqmc3fav2v">
                        <span className="font-semibold text-plum" data-id="element-235" data-mp="vsdpzf45inev">{t.name}</span>
                        {t.context && <span className="text-ink/70" data-id="element-236" data-mp="qtk8lblquc9f"> · {t.context}</span>}
                      </figcaption>}
                  </div>
                </figure>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}